import "./index.scss";

import classNames from "classnames";
import Markdown from "markdown-to-jsx";
import React from "react";

import Blockquote from "./Blockquote";
import Iframe from "./Iframe";
import Image from "./Image";
import Link from "./Link";
import Paragraph from "./Paragraph";

const Div = ({ children }: { children: string }) => {
    return <>{children}</>;
};
const Span = ({ children }: { children: string }) => {
    return <>{children}</>;
};
const TableHead = ({ children }: { children: string }) => {
    return <thead className="tablehead">{children}</thead>;
};
const TableData = ({ children }: { children: string }) => {
    return <td className="tabledata">{children}</td>;
};

const renderOptions = {
    forceBlock: true,
    overrides: {
        a: Link,
        span: Span,
        div: Div,
        p: Paragraph,
        blockquote: Blockquote,
        img: Image,
        iframe: Iframe,
        thead: TableHead,
        td: TableData,
    },
};

interface Props {
    content: string | undefined;
    className?: string;
    onContentRead?(): void;
}

const useIsElementVisible = (element: React.RefObject<HTMLDivElement>, contentId?: string) => {
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        setIsVisible(false);
        const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting));

        element.current && observer.observe(element.current);

        return () => {
            element.current && observer.unobserve(element.current);
        };
    }, [contentId]);

    return isVisible;
};

const MarkdownContent: React.FC<Props> = ({ content, className, onContentRead }) => {
    // ↵ comes from contentful as new line
    const bottomRef = React.useRef(null);
    const isBottomVisible = useIsElementVisible(bottomRef, content);

    React.useEffect(() => {
        if (isBottomVisible && onContentRead) {
            onContentRead();
        }
    }, [isBottomVisible]);

    return (
        <div className={classNames("markdown-content", className)}>
            <Markdown options={renderOptions}>{content!.replace(/↵/g, "<br/>")}</Markdown>
            <div className="bottom" ref={bottomRef} />
        </div>
    );
};

export default MarkdownContent;
